// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","703":"LazyIdentificationBusinessForm","886":"LazyInvitationStep","954":"LazyBusinessInfoFormComponent"}[chunkId] + "." + {"99":"cdd790e68fecc02d6f03","703":"7e220a0c80e03396e0e2","886":"4b3b1de1057eb07b47f6","954":"532acd0e986b730227f9"}[chunkId] + ".js";
};